(function (a) {
    a.divanteCookies = {
        render: function (b) {
            var c = "";
            (c +=
                '<div id="cookiesBar"><div id="cookiesBarWrap"><p>Używamy plików cookies (tzw. „ciasteczka”) w celu  optymalizacji korzystania ze stron internetowych, tworzenia statystyk,<br/> tworzenia i oceny efektywności naszych reklam. Możesz wyłączyć ten mechanizm w dowolnym momencie w ustawieniach przeglądarki. Zapoznaj się z naszą <a href="http://www.iccpaslek.pl/files/Polityka-prywatnosci.pdf" target="_blank">Polityką prywatności</a></p><a id="cookiesBarClose" class="button-link" href="#" title="Akceptuje">Akceptuje</a></div></div>'),
                a.cookie("cookie") ||
                    (a("body").append(c),
                    a.fn.delegate
                        ? a("#cookiesBar").delegate("#cookiesBarClose", "click", function (b) {
                              a.divanteCookies.closeCallback(b);
                          })
                        : a("#cookiesBarClose").bind("click", function (b) {
                              a.divanteCookies.closeCallback(b);
                          }));
        },
        closeCallback: function (b) {
            return a("#cookiesBar").fadeOut(), a.cookie("cookie") || a.cookie("cookie", !0, { path: "/", expires: 30 }), b.preventDefault(), !1;
        },
    };
})(jQuery);
